<template>
  <svg width="11"
       height="13"
       viewBox="0 0 11 13"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.7381 3.73193C1.15384 3.87828 0.497326 7.07753 2.30739 8.1972L1.82678 9.03306L0 7.97404V3.58898L3.17121 1.7506C3.04857 2.63102 3.34799 3.26335 3.7381 3.73193ZM8.69015 8.1972L9.17066 9.03306L10.9974 7.97402V3.58898L7.93418 1.81319C8.01811 2.56058 7.81806 3.19916 7.35321 3.73632C9.61099 3.87828 10.6637 6.85919 8.69015 8.1972ZM4.4881 8.86353H3.66646L1.62699 12.9998H2.44572L4.4881 8.86353ZM6.03695 11.8782L6.68843 12.2828L7.05211 11.7325L6.33934 11.4469L7.05211 11.1615L6.68843 10.6112L6.03695 11.0158L6.11226 10.318H5.37321L5.44586 11.0158L4.79698 10.6112L4.42986 11.1615L5.14522 11.4469L4.42984 11.7326L4.79701 12.2828L5.44586 11.8782L5.37321 12.5759H6.11226L6.03695 11.8782ZM9.22063 11.8782L9.87218 12.2828L10.2359 11.7325L9.52309 11.4469L10.2359 11.1615L9.87218 10.6112L9.22063 11.0158L9.29593 10.318H8.55686L8.62959 11.0158L7.98076 10.6112L7.61351 11.1615L8.32895 11.4469L7.61351 11.7326L7.98074 12.2827L8.62956 11.8782L8.55683 12.5759H9.29591L9.2206 11.8782L9.22063 11.8782ZM7.67785 2.13806C7.67785 0.49808 5.89757 -0.53245 4.48102 0.28754C3.06447 1.10753 3.0645 3.16861 4.48102 3.9886C5.89754 4.80859 7.67785 3.77804 7.67785 2.13806Z"
      fill="url(#paint0_linear_1641_9061)" />
    <defs>
      <linearGradient id="paint0_linear_1641_9061"
                      x1="5.49872"
                      y1="-0.000244141"
                      x2="5.49872"
                      y2="12.9998"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFBE15" />
        <stop offset="1" stop-color="#DFA613" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {}
}
</script>
